export class DynamicValue {
    constructor(light, dark) {
        this.light = light;
        this.dark = dark;
    }
}
//# sourceMappingURL=dynamic-value.js.map